import swal from "sweetalert";
import useUser from "../../../../core/hooks/use-user";
import Datatable from "../../../../core/ui/components/Datatable";
import { sweetAl, toast } from "../../../../core/helpers/message-helper";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import { pagarHoraExtra } from "../../services/horas-extras-service";

const Financiera = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();

    let tableButtons = [];

    if (userCan("nominaPagarHorasExtras")) {
        tableButtons.push({
            titleAttr: "Pagar horas",
            text: '<i class="fas fa-check"></i>',
            className: "btn btn-sm btn-secondary",
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea pagar estas horas extras?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        aceptar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se han pagado las horas extras");
                        break;
                    case "aceptar": {
                        const resp = await pagarHoraExtra(data);

                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al pagar las horas extras"
                            );
                        }

                        sweetAl.success("Las horas extras fueron pagadas");
                        dt.ajax.reload();
                        break;
                    }
                }
            },
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "horas-extras-financiera",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaFinanciera",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/turnos/horasExtras/financiera`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de horas extras"
                );
            },
        },
        columns: [
            { data: "info_persona" },
            { data: "nombre" },
            { data: "info_lider" },
            { data: "fecha" },
            { data: "observacion" },
            { data: "diurna" },
            { data: "nocturna" },
            { data: "diurna_festiva" },
            { data: "nocturna_festiva" },
            { data: "fecha_gerencia" },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    NÓMINA / Pago De Horas Extras
                    <small>Financiera</small>
                </div>
            </div>
            <Datatable options={dtOptions}>
                <table className="w-100 table table-hover" id="tablaFinanciera">
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Colaborador</th>
                            <th className="text-center text-white">Area</th>
                            <th className="text-center text-white">Responsable</th>
                            <th className="text-center text-white">Fecha Hora Extra</th>
                            <th className="text-center text-white">Observación al colaborador</th>
                            <th className="text-center text-white">Diurnas</th>
                            <th className="text-center text-white">Nocturnas</th>
                            <th className="text-center text-white">Diurnas festiva</th>
                            <th className="text-center text-white">Nocturnas festiva</th>
                            <th className="text-center text-white">Fecha aceptado por gerencia</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
        </ContentWrapper>
    );
};

export default Financiera;
